import { api } from "../apiCore";

export interface BalanceData {
  id: number;
  balance_date: string;
  balance_application_id: number;
  [key: `с_${string}`]: number; // Индексная подпись для ключей, начинающихся с 'c_'
}
export const financeApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Получение данных БО из внешних источников
    getAccountingBalanceData: builder.query<
      BalanceData,
      { year: number; applicationId: number; applicationBankId: number }
    >({
      query: ({ year, applicationId, applicationBankId }) => {
        return {
          url: `auth/applications/system-bank/create-data-to-bank/${applicationId}/application-bank/${applicationBankId}/search-accounting-balance?year=${year}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useGetAccountingBalanceDataQuery,
  useLazyGetAccountingBalanceDataQuery,
} = financeApi;
